import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "configs/http-interceptor";
import { RouterProvider } from "react-router-dom";
// import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
// import { store, persistor } from "./apis/store";
import router from "./router";
import Loading from "./components/Loading";
import store from "configs/store";

console.log('API URL:', process.env.REACT_PERKS_N_REWARDS_API);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <RouterProvider router={router} fallbackElement={<Loading />} />
      <Toaster
        toastOptions={{
          className: "",
          style: {
            padding: "16px",
            fontSize: "15px",
            fontWeight: 500,
          },
          position: "bottom-right",
        }}
      />
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>
);
